<!-- Context Menu on every Table Field -->
  <p-contextMenu #cm [model]="items" appendTo="body"  triggerEvent="click"></p-contextMenu>
  <!-- End of Context Menu on every Table Field -->

<p-confirmDialog  
  id="catAnalyticsComfirmation"
  acceptLabel="Ok" 
  rejectLabel= 'No'
  key="informationDialoge" 
  [rejectVisible]="false" 
  appendTo="body" 
  header="Information" 
  icon="pi pi-exclamation-triangle" 
  styleClass="confirm-dialog"
  [baseZIndex]="999999">
</p-confirmDialog>
<div class="panel-body nopadding">
  @if(isDataLoading){
  <div class="example-loading-shade">
   @if(isDataLoading){ <mat-spinner></mat-spinner>}
  </div>}

  <div class="ui-grid-col-12 text-right nopadding">
    <div class="col-lg-10">
      <mat-chip-listbox aria-label="filter">
        <span>
          <ng-container>
            <button pButton type="button" class="btn-bg-color-dark-blue" (click)="selectBackDate()">
              <i class="fa fa-backward"></i>
            </button>
            <button type="button" class="date-btn" (click)="this.showFilter()">
              {{  this.userService.getyyyyMMddDateFormate(reportDate)}}
            </button>
            <button pButton type="button" class="btn-bg-color-dark-blue" (click)="selectNextDate()">
              <i class="fa fa-forward"></i>
            </button>
          </ng-container>

          @for(activeFilter of activeFilters; track activeFilter+ '-'+ $index; let l = $index) {
          <a>
            <mat-chip selectable="true" [removable]="true" selected [matTooltip]="activeFilter.value"
              matTooltipPosition="after" [id]="activeFilter" [matTooltipShowDelay]="1000"
              >
              {{activeFilter.value}}
              @if(activeFilter.type !== 'Categories'){
              <mat-icon matChipRemove id="analytics-removeFilter"
                (click)="removeFilterLabel(l,activeFilter);getAllCommentCounts();">cancel</mat-icon>}
            </mat-chip>
          </a>}
        </span>
      </mat-chip-listbox>
    </div>
    <!-- Analytical Comments -->
    <div class="col-lg-2 pd-t-4 text-center">
      <ng-container>
        <label for="totalCommentCount" class="commentbtnWrapper">
          <p-button type="button" [ngClass]="'button btn-xs non-active-symbol'" (click)="sendPreparedParams('Browse-Comments', commentReportDates);openCatalystCommentViewer(true, false);">
            Browse Review Comments
          </p-button>
          <span class="btnBadge">{{totalCommentCount}}</span>
        </label>        
      </ng-container>
    </div>
    <!-- End of Analytical Comments -->
  </div>
  
  <div class="col-lg-12  mg-t-5 nopadding">
    <div class="ui-widget-header-1 nopadding">
      <div class="col-lg-1"><span>Group</span></div>
      @for(group of groupNames; track group+ '-'+ $index; let i = $index) {
      <ul class="nopadding">
        <label for="groupName">
          <p-button [id]="group" type="button"
            [ngClass]="group == this.groupName ? 'button btn-xs active-symbol' : 'button btn-xs non-active-symbol'"
            (click)="this.groupName = group;getCatAnalyticsData('groupName',group);getAllCommentCounts();">
            {{group}}
          </p-button>
        </label>
      </ul>}
    </div>
  </div>
  <div class="col-lg-12  mg-t-5 nopadding">
    <div class="ui-widget-header-1 nopadding">
      <div class="col-lg-1"><span>Asset Class</span></div>
      <ul class="nopadding">
        <label for="Equities">
          <p-button [id]="'Equities'" type="button"
            [ngClass]="'E' == this.assetClass ? 'button btn-xs active-symbol' : 'button btn-xs non-active-symbol'"
            (click)="this.assetClass = 'E';getCatAnalyticsData('assestClass','Equities');getAllCommentCounts();">
            Equities
          </p-button>
          <p-button [id]="'Option'" type="button"
            [ngClass]="'O' == this.assetClass ? 'button btn-xs active-symbol' : 'button btn-xs non-active-symbol'"
            (click)="this.assetClass = 'O';getCatAnalyticsData('assestClass','Option');getAllCommentCounts();">
            Option
          </p-button>
        </label>
      </ul>
    </div>
  </div>
  <div class="col-lg-12  mg-t-5 nopadding">
    <div class="ui-widget-header-1 nopadding">
      <div class="col-lg-1"><span>Categories</span></div>
      <ul class="nopadding">
        <label for="Events">
          <p-button [id]="'Events'" type="button" class="button btn-xs"
            [ngClass]="'Event' == activeCategory ? 'button btn-xs active-symbol  fw-bold' : 'button btn-xs non-active-symbol  fw-bold'"
            (click)="this.filterByName = 'type';getCatAnalyticsData('Categories','Events');this.activeCategory = 'Event';getAllCommentCounts();">
            Events
          </p-button>
          <p-button [id]="'Flags'" type="button" class="button btn-xs"
            [ngClass]="'Flags' == activeCategory ? 'button btn-xs active-symbol  fw-bold' : 'button btn-xs non-active-symbol  fw-bold'"
            (click)="getData('Categories','Flags');this.activeCategory = 'Flags';getAllCommentCounts();">
            Flags
          </p-button>
          <p-button [id]="'Handling Instruction'" type="button" class="button btn-xs"
            [ngClass]="'handlingInstructions' == activeCategory ? 'button btn-xs active-symbol  fw-bold' : 'button btn-xs non-active-symbol  fw-bold'"
            (click)="this.filterByName = 'handlingInstructions';this.activeCategory = 'handlingInstructions';getCatAnalyticsData('Categories','handlingInstructions');getAllCommentCounts();">
            Handling Instruction
          </p-button>
          <p-button [id]="'TIF'" type="button" class="button btn-xs"
            [ngClass]="'TIF' == activeCategory ? 'button btn-xs active-symbol  fw-bold' : 'button btn-xs non-active-symbol  fw-bold'"
            (click)="this.filterByName = 'timeInForce';getCatAnalyticsData('Categories','TIF');this.activeCategory = 'TIF';getAllCommentCounts();">
            TIF
          </p-button>
        </label>
      </ul>
    </div>
  </div>
  @if(activeCategory==='Flags'){
  <div class="col-lg-12  mg-t-5 nopadding">
    <div class="col-lg-1"> <span>Flags</span></div>
    <div class="ui-widget-header-1 nopadding">
      @for(filterlabel of fieldNames; track filterlabel+ '-'+ $index; let i= $index) {
      <ul class="nopadding">
        <label for="filterlabel">
          <p-button [id]="filterlabel"
            (click)="this.filterByName = filterlabel;getCatAnalyticsData('Flags',filterlabel);getAllCommentCounts();" type="button"
            [ngClass]="filterlabel == this.filterByName ? 'button btn-xs active-symbol' : 'button btn-xs non-active-symbol'">
            {{filterlabel}}
          </p-button>
        </label>
      </ul>}
    </div>
  </div>}
  <p-dialog [(visible)]="isVisible" styleClass="quick-view-grid-row y-hidden " icon="pi pi-exclamation-triangle"
    width="425" minHeight="0" appendTo="body" showEffect="fade" [modal]="true" (onHide)="isVisible = false"
    header="Date Filter" [focusOnShow]="false">
    <div class="col-lg-12 mg-t-5">
      <div class="col-lg-4"><label for="reportDate">Report Date</label></div>
      <div class="col-lg-8">
        <app-datepicker-calendar [date]="reportDate" [isDateRange]="false" (dateChange)="getDateEmitter()"></app-datepicker-calendar>
      </div>
    </div>
    <div class="col-lg-12 ">
      <div class="col-lg-4"></div>
      <div class="col-lg-8">

        <button type="button" class="btn-DodgerBlue mg-t-5 float-right" id="ApplyFilter"
          (click)="getColumns('dateFilter');isVisible=false">Apply Filter
        </button>
      </div>
    </div>
  </p-dialog>

  <div class="ui-grid-col-10  mg-t-5">
    <p-treeTable #tt id="parent-child-event-tree-table" [value]="treeData" [columns]="cols" selectionMode="single"
      [paginator]="true" [rows]="rows" alwaysShowPaginator="true" paginatorPosition="top"
      [rowsPerPageOptions]="constantService.DEFAULT_ROWSPERPAGEOPTION" [pageLinks]="constantService.DEFAULT_PAGELINKS"
      (onNodeCollapse)="nodeUnselect($event)" (onNodeExpand)="nodeSelect($event)" [totalRecords]="treeData?.length" showGridlines>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length">
            {{isDataLoading?constantService.LOADIND_DATA_MSG:constantService.NO_RECORDFOUND_MSG}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          @for(col of columns; track col+ '-'+ $index; let headerIndex = $index) {
          <th id="columns" [ngClass]="(headerIndex > 0 ? 'cursor-pointer' : '')" (click)="headerIndex>0 && OnHeaderClick(col.field)">
            <span>{{col.header}}</span>
            @if(headerIndex > 0){
            <span class="cellHeaderBadge cursor-pointer">{{col.commentCount}}</span>}
          </th>}
        </tr>
        <tr>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr [ttRow]="rowNode">
          @for(col of columns; track col+ '-'+ $index; let i = $index) {
          <ng-container>
            @if(i==0){
            <td>
              <p-treeTableToggler [rowNode]="rowNode" class="iconButton">
              </p-treeTableToggler>
              <span>{{rowData[col.field]}}</span>
            </td>}
          </ng-container>}

          @for(col of columns; track col+ '-'+ $index; let i = $index) {
          <ng-container> 
            <!-- {{rowData[col.field] | json}} -->
            @if(i!==0){
            <td (contextmenu)="onContextMenu($event,[rowData, [col.field]])" [ngClass]="rowData[col.field].cellStaus ? rowData[col.field].class : 'float-center'" style="text-align: center !important;">
              @if(!rowData.isActiveLink ? true : i<=2){
              <span [id]="rowData[col.field].value + '_'+ i">{{rowData[col.field].value| number }}</span>}
              @if(rowData.isActiveLink && i>2){
              <span>
                    <a matTooltip="View ROE Details" [matTooltipShowDelay]="1000" appendTo="body" [id]="rowData[col.field].value + '_'+ i"
                    (click)="goToCatRoeViewer(rowData,col,rowData[col.field].value)"
                    [class]="rowData[col.field].cellTextColor">{{rowData[col.field].value| number }}</a>
                </span>}
            </td>}
          </ng-container>}

        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorright">
        <button type="button" 
        [matTooltip]="this.userService.enableFileExport()?
                    'Export':'Export service is disabled'"
        [matTooltipShowDelay]="1000"  id="export-tree" label="export-tree" class="exportBtn"
          (click)="exportToCSV()"> Export <i class="fa fa-download" aria-hidden="true"></i>
        </button>
        <p-button type="button" id="analytics-tree-expand-collapse" (click)="exapandORcollapse(treeData, 'one-level')"> {{buttonCaption}}
        </p-button>
        <p-button type="button" id="analytics-tree-expand-collapse-all" (click)="exapandORcollapse(treeData,'all-level')"> {{buttonCaption}} All
        </p-button>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        Total Records: {{this.eventTreeService.dataArray.length}}
      </ng-template>
    </p-treeTable>
  </div>

  <div class="ui-grid-col-2" style="text-align: center !important;">

    <div >
      <div class="ui-grid-col-12 bg-white">
        <div class="ui-grid-col-4">
          <span><b>Threshold</b>  </span>
        </div>
        <div class="ui-grid-col-8">
          <span><b>= Daily Variance +</b> </span>
        </div>
        <div class="ui-g-offset-4 ui-grid-col-8 thresholdSection1">
          <input type="number" style="width: 40%;" [(ngModel)]="percentageChange" ngDefaultControl>%
          <p-button type="button" (click)="applyThreshold()">Apply </p-button>
        </div>
      </div>
      <div class="ui-g-offset-3 ui-grid-col-8 pd-t-10 thresholdSection">
        <div class="FFFFCC">Threshold</div>
        <div class="FFFF99">Threshold + 30%</div>
        <div class="FFFF00">Threshold + 50%</div>
        <div class="FFCC99">Threshold + 100%</div>
        <div class="FFB266">Threshold + 150%</div>
        <div class="FF9933">Threshold + 200%</div>
        <div class="FF8000">Threshold >= 300%</div>
        <div class="pd-t-10"></div>
        <div class="FFCCFF">Daily <= 50% of 5D Avg</div>
        <div class="FF99FF">Daily <= 75% of 5D Avg</div>
      </div>
    </div>
  </div>
</div>
<!-- Anlytical Comments -->
<app-catalyst-comment-viewer
  (reloadCommentCount)="getAllCommentCounts()"
  [selectedRow]="selectedRowData"
  [dailyVariance]="percentageChange">
</app-catalyst-comment-viewer>